import { render } from "./KanbanViewDynamic.vue?vue&type=template&id=f97b09ca"
import script from "./KanbanViewDynamic.vue?vue&type=script&lang=js"
export * from "./KanbanViewDynamic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__